"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _axios = _interopRequireDefault(require("axios"));

var _basic = _interopRequireDefault(require("./_basic"));

var _bluebird = _interopRequireDefault(require("bluebird"));

var DashboardApi =
/*#__PURE__*/
function (_BasicApi) {
  (0, _inherits2.default)(DashboardApi, _BasicApi);

  /**
   * @constructor
   */
  function DashboardApi(_ref) {
    var _this;

    var dataHubUrl = _ref.dataHubUrl,
        userTokenFactory = _ref.userTokenFactory;
    (0, _classCallCheck2.default)(this, DashboardApi);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(DashboardApi).call(this, {
      userTokenFactory: userTokenFactory
    }));
    _this.dataHubUrl = dataHubUrl;
    return _this;
  }

  (0, _createClass2.default)(DashboardApi, [{
    key: "dashboardNavUrl",
    value: function dashboardNavUrl(_ref2) {
      var accId = _ref2.accId,
          usrId = _ref2.usrId;
      return "".concat(this.dataHubUrl, "/acc/").concat(accId, "/usr/").concat(usrId, "/dashboard/nav");
    }
  }, {
    key: "dashboardViewUrl",
    value: function dashboardViewUrl(_ref3) {
      var accId = _ref3.accId,
          usrId = _ref3.usrId,
          viewId = _ref3.viewId;
      return "".concat(this.dataHubUrl, "/acc/").concat(accId, "/usr/").concat(usrId, "/dashboard/").concat(viewId);
    }
  }, {
    key: "dashboardCustomViewUrl",
    value: function dashboardCustomViewUrl(_ref4) {
      var accId = _ref4.accId,
          usrId = _ref4.usrId,
          viewId = _ref4.viewId,
          accountId = _ref4.accountId;
      return "".concat(this.dataHubUrl, "/acc/").concat(accId, "/usr/").concat(usrId, "/dashboard/").concat(viewId, "/cstm/").concat(accountId);
    }
  }, {
    key: "getNavigation",
    value: function () {
      var _getNavigation = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(_ref5) {
        var _this2 = this;

        var accId, usrId, headers;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                accId = _ref5.accId, usrId = _ref5.usrId;
                _context.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context.sent;
                return _context.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(_this2.dashboardNavUrl({
                    accId: accId,
                    usrId: usrId
                  }), headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getNavigation(_x) {
        return _getNavigation.apply(this, arguments);
      }

      return getNavigation;
    }()
  }, {
    key: "getViewById",
    value: function () {
      var _getViewById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref6) {
        var accId, usrId, viewId, _ref6$accountId, accountId, headers, url;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                accId = _ref6.accId, usrId = _ref6.usrId, viewId = _ref6.viewId, _ref6$accountId = _ref6.accountId, accountId = _ref6$accountId === void 0 ? null : _ref6$accountId;
                _context2.next = 3;
                return this.getHeaders();

              case 3:
                headers = _context2.sent;
                url = accountId ? this.dashboardCustomViewUrl({
                  accId: accId,
                  usrId: usrId,
                  viewId: viewId,
                  accountId: accountId
                }) : this.dashboardViewUrl({
                  accId: accId,
                  usrId: usrId,
                  viewId: viewId
                });
                return _context2.abrupt("return", _bluebird.default.try(function () {
                  return _axios.default.get(url, headers);
                }).then(function (response) {
                  return _bluebird.default.resolve(response.data);
                }));

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getViewById(_x2) {
        return _getViewById.apply(this, arguments);
      }

      return getViewById;
    }()
  }]);
  return DashboardApi;
}(_basic.default);

var _default = DashboardApi;
exports.default = _default;